import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * The standard `cn()` helper used by shadcn/ui — merge tailwind classes
 * intelligently, dedupe conflicts (last-wins) so prop overrides work.
 *
 *   cn("px-2 py-1", isActive && "bg-blue-500", className)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
